// Create: src/components/ControlledToggleSwitch/index.tsx
import React from 'react';
import { Controller } from 'react-hook-form';
import './index.css';

interface ControlledToggleSwitchProps {
  inputName: string;
  control: any;
  leftLabel: string;
  rightLabel: string;
  defaultValue?: boolean;
  isDisabled?: boolean;
  onChange?: (value: boolean) => void;
}

const ControlledToggleSwitch: React.FC<ControlledToggleSwitchProps> = ({
  inputName,
  control,
  leftLabel,
  rightLabel,
  defaultValue = false,
  isDisabled = false,
  onChange
}) => {
  return (
    <Controller
      name={inputName}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange: fieldOnChange } }) => (
        <div className={`toggle-switch-create-order-container ${isDisabled ? 'disabled' : ''}`}>
          <div className="toggle-switch-create-order-wrapper">
            <span 
              className={`toggle-create-order-label left ${!value ? 'active' : ''}`}
              onClick={() => {
                if (!isDisabled) {
                  fieldOnChange(false);
                  onChange?.(false);
                }
              }}
            >
              {leftLabel}
            </span>
            
            <div 
              className={`toggle-switch-create-order ${value ? 'on' : 'off'} ${isDisabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!isDisabled) {
                  const newValue = !value;
                  fieldOnChange(newValue);
                  onChange?.(newValue);
                }
              }}
            >
              <div className="toggle-slider-create-order"></div>
            </div>
            
            <span 
              className={`toggle-label-create-order right ${value ? 'active' : ''}`}
              onClick={() => {
                if (!isDisabled) {
                  fieldOnChange(true);
                  onChange?.(true);
                }
              }}
            >
              {rightLabel}
            </span>
          </div>
        </div>
      )}
    />
  );
};

export default ControlledToggleSwitch;